/**
 * генератор запросов к API авторизации
 * возвращает класс, который собирает структуру для генерации actions, reducer и middleware
 */
import _ from "lodash";
import qs from "query-string";
import { combineReducers } from "redux";

// здесь будут уже сконфигурированные редюсеры
import { SUCCESS, REQUEST, FAILURE } from "./init";
import authReducers from "./reducers";

export default authReducers;

// типовой редюсер для API
export function reducer(state = {}, action) {
  console.log("do regular reducer", action);
  const { payload } = action;
  switch (action.type) {
    case SUCCESS:
      return { ...state, body: payload.body };

    case FAILURE:
      return {
        ...state,
        error: _.get(payload, "response.message") || payload.statusText,
      };

    case REQUEST:
      return { ...state, timestamp: new Date() };

    default:
      return state;
  }
}

export const authAPIReducer = combineReducers({
  api: reducer,
  ...authReducers.reducers,
});
// export const adminAPIReducer = reducer;

export const authAPIMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  const { payload } = action;

  // если по какой-то причине вернулся 409, то полностью обновим страницу
  // это означает, что умерла кука сессии, или сломался отпечаток клиента
  // if (409 === _.get(payload, "status")) {
  //   document.location.reload();
  // }

  return result;
};

export const middlewares = [authAPIMiddleware, ...authReducers.middlewares];

export const applyUrlParams = (url, params = {}, query = {}) => {
  // todo replace keys in url by params
  _.each(params, (value, key) => {
    url = url.replace(`{${key}}`, value);
  });
  return url + "?" + qs.stringify(query);
};

export const STATS_API = process.env.REACT_APP_STATS_API;

export const autoDetect = (url, method) => {
  let route = {};

  if (method === "AUTO") {
    route = _.get(window.cloclo_routes, url);
    if (!route) {
      throw console.log(`no auto route ${url}`);
    }
  }
  // /*
  route.path && (url = route.path);
  route.method && (method = route.method);

  return { url, method };
};

export const generateUrl = (url, { params, query } = {}) => {
  return `${STATS_API}${applyUrlParams(url, params, query)}`;
};

export const corsUrl = (url) => {
  const CORS_ANYWHERE_URL =
    process.env.REACT_APP_CORS_ANYWHERE || "https://cors-anywhere.herokuapp.com";
  return `${CORS_ANYWHERE_URL}/${url}`;
};
